import {
    Component, Input, Output, EventEmitter, OnInit,
    AfterViewInit, AfterViewChecked, ElementRef, OnChanges
} from '@angular/core';
import { map, catchError } from 'rxjs/operators';



@Component({
    selector: 'app-usage-bar',
    templateUrl: './usage-bar.component.html',
    styleUrls: ['./usage-bar.component.scss']
})
export class UsageBarComponent implements OnInit, OnChanges { // [Anand] changed class name for standards

    @Input() totalValue: number;

    @Input() dynamicValue: number;

    @Input() leftText: string;

    @Input() rightText: string;

    @Input() valueDirection: string;

    barWidth: number;

    constructor() {
    }

    ngOnInit() {
        this.barWidth = (this.dynamicValue / this.totalValue) * 100;
    }

    ngOnChanges() {
        this.barWidth = (this.dynamicValue / this.totalValue) * 100;
    }


}
